export const locale = {
    lang: 'ar',
    data: {
        PROJECTS_BOARD_DIALOGS_ATTACHEMENT_DISPLAY_CLOSE: ' أغلق',
    }
};
